module.exports = __webpack_public_path__ + "static/media/11.6a6366b5.png";